import { render, staticRenderFns } from "./CoachesPanel.vue?vue&type=template&id=10a0436a&"
import script from "./CoachesPanel.vue?vue&type=script&lang=js&"
export * from "./CoachesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports